import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { Listclients } from '../store/slices/client';
import { Listpartners } from '../store/slices/partners';
import { FaFileExcel} from 'react-icons/fa';
import Navbarside from './Navbarside';
import Loader from '../common/Loader';
import Footer from './Footer';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import Table from '../common/Table';
import { generateExcelFile } from '../common/ExcelDownload';

const Item = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.id;
  const Name = user?.data?.company_name;
  const user_type = user?.data?.user_type;
  const userPartner_id=user?.data?.partner_id;

  const [isLoading, setIsLoading] = useState(false);
  const [listclients, setListclients] = useState([]);
  const [columns, setcolumns] = useState([
    { header: 'Name', field: 'name' },
    { header: 'Company Name', field: 'company_name' },
    { header: 'Partner Name', field: 'partner_name' },
    { header: 'Activation Date', field: 'licence_activation_date' },
    { header: 'Remaining Days', field: 'remaining_days' },
    { 
      header: 'Actions', 
      field: 'actions', 
      isAction: true, 
      actionButtons: [
        { name: 'Edit', className: 'btn-default' }, 
        { name: 'View Dashboard', className: 'btn-default top-button' }, 
      ]
    }
  ]);

  const [formData, setFormData] = useState({
     partner_id : ''
  });
 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [listParties, setListpartners] = useState([]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
      navigate(`/clients/edit/${item.id ? item.id : null}`)
      // Implement your edit logic here
  };

  const handleViewDashboard = (item) => {
    navigate(`/clients/dashboard/${item.id ? item.id : null}`, {
      state: { company_name: item.company_name },  // Send the company name via state
    })
    // Implement your edit logic here
};

  const handleDelete = (item) => {
    console.log('Deleting item:', item);
    // Implement your delete logic here
  };

  const partyOptions = listParties.map((party) => ({
      value: party.id,
      label: party.name,
  }));


// Fetch parties
useEffect(() => {
  setIsLoading(true);
  dispatch(Listpartners())
    .unwrap()
    .then((data) => {
      setIsLoading(false);
      setListpartners(data?.data);
    })
    .catch(({ message }) => {
      setIsLoading(false);
      console.log(message);
    });
}, [dispatch, id]);

const handleInputChange = (selectedOption, actionMeta) => {
  const value = selectedOption.value;
  
  if (actionMeta.name === 'partner_id') {
    setFormData((prevState) => ({
      ...prevState,
      [actionMeta.name]: value, 
    }));
    console.log('Selected value:', value);

    dispatch(Listclients({ profile_id: value }))
      .unwrap()
      .then((response) => {
        if(response?.data){
          setListclients(response?.data);
        }
        else{
          setListclients('');
        }
        
      })
      .catch((error) => {
        console.log('Error fetching client list:', error);
      });
  }
};




useEffect(() => {
  const fetchClients = async () => {
    setIsLoading(true);
    try {
      let params = {
        page: currentPage,
        limit: pageSize,
      };

      if (user_type === "Partner") {
        params.profile_id = id;
      } else if (user_type !== "Admin") {
        params.profile_id = id;
        params.user_type = user_type;
        params.partner_id = userPartner_id;
      }
      const action = Listclients(params);
      const response = await dispatch(action).unwrap();

      setListclients(response?.data || []);
    } catch (error) {
      console.error("Error fetching clients:", error.message || error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchClients();
}, [ id, user_type, userPartner_id, currentPage, pageSize]);



  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

const filtereditemList = listclients?.filter(party => {
  const query = searchQuery?.toLowerCase();
  return (
    party?.name?.toLowerCase()?.includes(query) ||
    party?.company_name?.toLowerCase()?.includes(query) ||
    party?.partner_name?.toLowerCase()?.includes(query) ||
    party?.date_added?.toLowerCase()?.includes(query)
  );
});

  const formatDate = (dateString) => {
    return dateString
      ? new Date(dateString).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        })
      : "";
  };

const handleExcelDownload = () => {
  if (!listclients || listclients.length === 0) {
    alert('No client data available to download.');
    return;
  }

  const transformData = (data) =>
    data.map((client) => ({
      Name: client.name || '',
      "Company Name": client.company_name || '',
      "Partner Name": client.partner_name || '',
      "Activation Date": formatDate(client.licence_activation_date) || '',
      "Remaining Days": client.remaining_days || '',
    }));

  generateExcelFile(
    listclients,
    'Clients_List.xlsx',
    'Clients',
    transformData,
    'Client List Report'
  );
};


  return (
    <div>
      <div className="row" style={{ marginLeft: '0', marginRight: '0' }}>
        <Navbarside />
        {isLoading && <Loader />}
        <div className="container ">
            <div className="col-md-12 ">
            <div className="row content-body">
                <div className="container-fluid">
                <div className="page-header">
                    <div>
                    <h2 className="main-content-title tx-24 mg-b-5">Clients List</h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                        <a href="#">Clients</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                           Clients List
                        </li>
                    </ol>
                    </div>
                    {(user_type === 'Admin' || user_type === 'Partner') && (
                    <div className="d-flex justify-content-end">
                        <button className="btn ripple btn-default" onClick={() => navigate('/clients/add')}>
                            Add Client
                        </button>
                         <button className="btn ripple btn-default" onClick={handleExcelDownload}>
                           Export Excel <FaFileExcel />
                        </button>
                    </div>
                    
                              )}
                </div>

                <div className="row">
                {(user_type === 'Admin') && (
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-6">
                            <label>Client Ownership <span class="required">*</span> </label>
                                 <Select options={partyOptions} name="partner_id" placeholder="--Select Customer--" onChange={handleInputChange}  />
                            </div>
                        </div>
                    </div>
                         )}
                    <div className="col-md-12">
                    <Table
                        columns={columns}
                        data={filtereditemList}
                        tableRef={tableRef}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        currentPage={currentPage}
                        totalCount={filtereditemList?.length}
                        onPageChange={handlePageChange}
                        handleEdit={handleEdit}
                        handleViewDashboard={handleViewDashboard}
                        handleDelete={handleDelete}
                        handleSearchChange={handleSearchChange}
                    />
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Item;
